<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCancel()"
  ></button>
</div>

<div class="modal-body">
  <p *ngIf="message">{{ message }}</p>

  <ng-content></ng-content>
</div>

<div class="modal-footer" *ngIf="showFooter">
  <button type="button" class="btn btn-secondary" (click)="onCancel()">
    {{ cancelLabel }}
  </button>
  <button type="button" class="btn btn-danger" (click)="onConfirm()">
    {{ confirmLabel }}
  </button>
</div>
